import { CurrencyPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { BigNumbersPipe, EndsWithPipe } from '@zero/shared/ui-pipes';
import { InstrumentDetailsLinkComponent, WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { DividendYield, Position } from '@zero/shared/util-models';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[zero-position-dividend]',
  templateUrl: './position-dividend.component.html',
  styleUrls: ['./position-dividend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BlinkDirective,
    CurrencyPipe,
    FormsModule,
    InstrumentDetailsLinkComponent,
    NgClass,
    NgTemplateOutlet,
    TranslocoPipe,
    WatchlistToggleComponent,
    BigNumbersPipe,
    EndsWithPipe,
  ],
})
export class PositionDividendComponent implements OnChanges {
  @Input() public item: Position;
  @Input() public dividendYield: DividendYield;
  @Input() public dividendPeriods: string[];

  public currentYear: string = new Date().getFullYear().toString();

  public dividendAbsoluteValues: Record<string, number> = {};
  public dividendYieldValues: Record<string, number> = {};

  public ngOnChanges(): void {
    this.calculateDividendValues();
  }

  private calculateDividendValues(): void {
    this.dividendAbsoluteValues = {};
    this.dividendYieldValues = {};

    if (this.dividendYield?.receivedPeriods?.length) {
      this.dividendYield.receivedPeriods.forEach((dividend) => {
        this.dividendAbsoluteValues[dividend.period] = dividend.dividendAbsolute;
        this.dividendYieldValues[dividend.period] = dividend.dividendYield;
      });
    }
    if (this.dividendYield?.receivedDividendTotal) {
      const total = this.dividendYield.receivedDividendTotal;
      this.dividendAbsoluteValues[total.period] = total.dividendAbsolute;
      this.dividendYieldValues[total.period] = total.dividendYield;
    }

    if (this.dividendYield?.forecastedPeriods?.length) {
      this.dividendYield.forecastedPeriods.forEach((dividend) => {
        this.dividendAbsoluteValues[`${dividend.period}e`] = dividend.dividendAbsolute;
      });
    }
  }
}
